import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconNames } from '../../common/constants/icon-names';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-pdf-icon',
  imports: [SvgIconComponent],
  templateUrl: './pdf-icon.component.html',
  styleUrls: ['./pdf-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfIconComponent {
  @Input() fileName: string;
  @Input() isCursorNeeded = false;

  @Output() iconClick: EventEmitter<void> = new EventEmitter();

  iconNames = IconNames;

  onIconClick(): void {
    this.iconClick.emit();
  }
}
